import { createFileRoute } from '@tanstack/react-router'
import { Explainers } from '@/pages/Explainers'

export const Route = createFileRoute('/_authenticated/explainers')({
  component: Explainers,
})
